export default class MyBindings{
	constructor(me){
		this._propertyBindings = new Set()
		this._disposed=false;
		this.add = this.add.bind(this);
		this.remove = this.remove.bind(this);
		this.dispose = this.dispose.bind(this);
		this.reset = this.reset.bind(this);
	}
	add(propertyBinding){
		if(this._propertyBindings.has(propertyBinding))return;
		this._propertyBindings.add(propertyBinding);
	}
	remove(propertyBinding){
		if(this._propertyBindings.has(propertyBinding))
			return;
		this._propertyBindings.delete(propertyBinding);
	}
	reset(){
		this._propertyBindings.forEach((propertyBinding)=>{
			propertyBinding.unbind();
		});
		this._propertyBindings=new Set();
	}
	dispose(){	
		if(this._disposed)
			return;
		this._disposed=true;
		this.reset();
	}
}